/**
 * Constantes de colores del tema sincronizadas con _variables.scss
 * Estas constantes se usan en theme.ts para evitar valores hardcodeados
 * 
 * IMPORTANTE: Si cambias valores en _variables.scss, actualiza también estos valores
 */

export const THEME_COLORS = {
  schemes: {
    secondary: '#B5CCBB', // $schemes-secondary
    onSurfaceVariant: '#BFBFBF', // $schemes-on-surface-variant
    primary: '#BCEA42', // $schemes-primary
  },
  error: '#FF5455', // $error-color
} as const;


